export const userColumns = [
  {
    field: "id",
    headerName: "S.No.",
    width: 70,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "name",
    headerName: "Name of Firm/Company",
    width: 500,
    headerClassName: "super-app-theme--header",
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  {
    field: "date",
    headerName: "Date of Event",
    width: 360,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },

  {
    field: "speaker",
    headerName: "Details of Event",
    width: 460,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },

  {
    field: "course",
    headerName: " Target Participant",
    width: 380,
    headerAlign: "center",
    align: "center",
    sortable: false,
  },
  
];

export const userRows = [
{
  id:"1",
  name:"Workshop on Getting Started with Azure Cloud",
  date:"28th July 2023 02:00 PM onwards",
  speaker:"RPS Consulting",
  course:"B.Tech./M.Tech./MCA (Batch 2024,2025,2026)"
},

{
  id:"2",
  name:"Webinar on AI Uncovered - A journey into the world of AI and its future",
  date:"4th August 2023 05:00 PM Onwards",
  speaker:"TCS Launchpad Mr. Shreedhar V Developer at TCS Innovation Lab",
  course:"B.Tech./M.Tech./MCA (Batch 2024,2025,2026)"
},

{
  id:"3",
  name:"Workshop on Azure Administrator",
  date:"8th Aug 2023 02:00 PM onwards",
  speaker:"RPS Consulting",
  course:"B.Tech./M.Tech./MCA (Batch 2024,2025,2026)"
},

{
  id:"4",
  name:"Seminar on 5G Technology and Digital Revolution",
  date:"22nd Aug 2023 03:00 PM Onwards",
  speaker:"Mr. PranayPathak State Head, Reliance Jio",
  course:"B.Tech ECE (2024/25)"
},

{
  id:"5",
  name:"Webinar on Industrial Management in Microelectronics",
  date:"24th Aug 2023 03:00 PM Onwards",
  speaker:"Prof. Dr. Gerald Gerlach Chair - Institute of Solid-State Electronics, TUD Germany",
  course:"B.Tech./M.Tech./MCA (Batch 2024,2025,2026)"
},

{
  id:"6",
  name:"Seminar on Navigating Tomorrow's Job Market: Strategies for College Placement Success",
  date:"12th Sept 2023 10:30 AM Onwards",
  speaker:"Sh. B.B. Singh Ex Principle MMMUT, Prof at KIPM",
  course:"B.Tech./M.Tech./MCA (Batch 2024,2025,2026)"
},

{
  id:"7",
  name:"Seminar on Data Science using Python",
  date:"16 Sept 2023 10:00 AM Onwards",
  speaker:"Siddhartha Mishra Founder, Deep Dive Consulting Pvt. Ltd",
  course:"B.Tech./M.Tech./MCA (Batch 2024,2025,2026)"
},
  
{
  id:"8",
  name:"Expert Talk on Scope and Avenue in Telecom Industry",
  date:"19 Sept 2023 02:30 PM Onwards",
  speaker:"Sh. Rajesh Rai CMD, ITI",
  course:"B.Tech./M.Tech./MCA (Batch 2024,2025,2026)"
},

{
  id:"9",
  name:"Webinar on preparation of Civil Services",
  date:"1st Oct 2023 11:00 AM Onwards",
  speaker:"Mr. Pulkit Singh, IAS 2020 & Ms. JyotiYadav, Academic Coach",
  course:"BBA/MBA/B.Tech/M.Tech/MCA/MSc(2024/2025/2026)"
},

{
  id:"10",
  name:"Expert Talk on Career opportunities in IT sector and Preparation strategy",
  date:"14th Oct 2023 03:00 PM onwards",
  speaker:"Mr. PawanPundir Senior Engineering Manager at Flipkart",
  course:"B.Tech./M.Tech./MCA (Batch 2024,2025,2026)"
},

{
  id:"11",
  name:"Expert Talk on Crafting Your Career: Hiring trends in current scenario",
  date:"14th Oct 2023 12:00 PM onwards",
  speaker:"Mr. ShresthSahai SDE, Tact.AI",
  course:"B.Tech./M.Tech./MCA (Batch 2024,2025,2026)"
},

{
  id:"12",
  name:"TCS Interaction (CodeVita Season XI)",
  date:"26th October 2023, Thursday | 12:00 PM to 1:00 PM",
  speaker:"TCS",
  course:"B.Tech./M.Tech./MCA (Batch 2024,2025,2026)"
},

{
  id:"13",
  name:"Aptitude test on Engineering Concepts",
  date:"30th Oct 10:30 AM – 01:00 PM",
  speaker:"Jaipuriya Institute of Management, Lko",
  course:"B.Tech. (Batch 2024,2025,2026)"
},

{
  id:"14",
  name:"Expert Talk on The Future is faster than you think. Modern trends in IT",
  date:"2nd Nov 04:00 PM onwards",
  speaker:"Sushil Sharma R&D Engineering Manager, Hewlett Packard Inc",
  course:"B.Tech./M.Tech./MCA (Batch 2024,2025,2026)"
},

{
  id:"15",
  name:"Preparation Strategy for Civil Services",
  date:"6th Nov 11:00 AM Onwards",
  speaker:"Shivam Gupta Bihar PCS",
  course:"BBA/MBA"
},

{
  id:"16",
  name:"Interaction Session about CodeVita Season XI",
  date:"7th Nov 11:00 AM Onwards",
  speaker:"TCS Team",
  course:"B.Tech./M.Tech./MCA (Batch 2024,2025,2026)"
},

{
  id:"17",
  name:"Exposure to Advance Studies in MS/ MBA Programs",
  date:"9th Nov 11:00 AM Onwards",
  speaker:"ArvindVerma, Reshma Singh",
  course:"Btech/BBA/BPharma"
},

{
  id:"18",
  name:"Expert talk on Job Opportunities in USA",
  date:"4th Dec 12:00 PM onwards",
  speaker:"ErAtulGarg Campbella Soup Company",
  course:"B.Tech./M.Tech./MCA (Batch 2024,2025,2026)"
},

{
  id:"19",
  name:"Expert talk on Career Opportunities in Cyber Security",
  date:"4th Dec 01:00 PM onwards",
  speaker:"Dr. Jitendra Mohan Bhardwaj Tata Advanced Systems Ltd",
  course:"B.Tech./M.Tech./MCA (Batch 2024,2025,2026)"
},

{
  id:"20",
  name:"Expert talk on Placement Strategies and Competitive Programming",
  date:"4th Dec 03:00 PM onwards",
  speaker:"Ms. AradhyaTripathi Mr. UtkarshGoel SWE at Google",
  course:"B.Tech./M.Tech./MCA (Batch 2024,2025,2026)"
},

{
  id:"21",
  name:"Workshop on Communication Skills",
  date:"15th Dec 02:00 PM onwards",
  speaker:"Dr. Chandraketu Singh Faculty, Jaipuria Institute of Management, Lucknow",
  course:"BBA/BPharma/MBA(2024/2025/2026)"
},

{
  id:"22",
  name:"Placement Strategies and Resume making",
  date:"12th Dec 06:00 PM onwards",
  speaker:"Mr. Lokesh Sharma SDE at Deloitte",
  course:"B.Tech/M.Tech/MCA/MBA/BBA(2024/2025/2026)"
},

{
  id:"23",
  name:"Workshop on AI for Students: Build Your Own Generative AI Model",
  date:"27th Jan 11:00 AM onwards",
  speaker:"TrivikramaKothinti CEO of ProYuga",
  course:"B.Tech/M.Tech/MCA(2024/2025/2026/2027)"
},

{
  id:"24",
  name:"Job Opportunities in the Area of Computing Machinery",
  date:"10th Feb 12:00 PM onwards",
  speaker:"Dr. AlokSrivastava Ambassador and Foreign Executive Secretary",
  course:"B.Tech/M.Tech/MCA(2024/2025/2026/2027)"
},

{
  id:"25",
  name:"Workshop on VLSI Design Methodologies",
  date:"11th Feb 06:30 PM onwards",
  speaker:"WayspireEdTechPvt Ltd",
  course:"B.Tech/M.Tech/MCA(2024/2025/2026/2027)"
},

{
  id:"26",
  name:"Webinar on Automotive Connectivity in the era of SDVs & V2X Communications",
  date:"23rd Feb 03:00 PM onwards",
  speaker:"Mr. Vishesh Kumar Technical Architect | V2X SDV",
  course:"B.Tech/M.Tech/MCA(2024/2025/2026/2027)"
},

{
  id:"27",
  name:"Expert Talk on preparation strategies of civil services",
  date:"24th Feb 10:00 AM onwards",
  speaker:"Mr. GauravTripathi IPS | 2022",
  course:"B.Tech/M.Tech/MCA(2027)"
},

{
  id:"28",
  name:"Worshop on Pressure Vessel Design Using ASME Codes",
  date:"25th Feb 09:30 AM onwards",
  speaker:"Team Scootoid",
  course:"Mechanical Engineering(2024/2025/2026/2027)"
},

{
  id:"29",
  name:"Webinar on Placement Strategies and Industry Experience",
  date:"9th March 11:00 AM onwards",
  speaker:"Mr. AmitPandey GIC Practice Lead at IBM",
  course:"Btech/MCA2024/2025"
},

{
  id:"30",
  name:"Python Learning Workshop",
  date:"22nd March",
  speaker:"Accenture",
  course:"All students of Btech Final Year"
},

{
  id:"31",
  name:"Webinar on E Mobility System Engineering Hardware and Software Integration",
  date:"26th March 03:00 PM onwards",
  speaker:"Mr. Vatsal Shah Program Director for Electric Vehicles at Skill-Lync",
  course:"B.Tech/M.Tech/MCA(Batch 2025/2026)"
},

{
  id:"32",
  name:"Personality Development and Interview Technique Session",
  date:"2nd April to 10th April",
  speaker:"Mr. Vibhav Srivastava",
  course:"All Pre-Final Year studentsof all branches | Batch2025"
},

{
  id:"33",
  name:"Career guidance webinar",
  date:"Tentative",
  speaker:"Skill dunia and Ecell IIT Hyderabad",
  course:"Open to all departments andbranches"
},

{
  id:"34",
  name:"Training Courses on Artificial Intelligence (AI) and ChatGPT",
  date:"June",
  speaker:"Niit Foundation",
  course:"Open to all departments and branches"
},

{
  id:"35",name:"Expert Talk on Professional Advice for TOEFL and GRE Preparation",
  date:"9th June",
  speaker:"Mr. Joseph Augustine",
  course:"B.Tech./M.Tech./MCA/BBA/MBA/B.Pharma/M.Sc. (2025/2026/2027)"
},

{
  id:"36",
  name:"Webinar on Explore a career in AI and IOT Powered Supply chai and Operation Management",
  date:"13th June",
  speaker:"Mr. Asoke Das Sarma, Prof. Milann Kumar, Prof. Neena Pandey",
  course:"B.Tech./M.Tech./MCA/MBA/BBA (2025/2026/2027)"
},

{
  id:"37",
  name:"Workshop on Data Analytics & AI",
  date:"15th June",
  speaker:"Dr. Mendus Jacob, Dr. Sunil Job K A",
  course:"B.Tech./M.Tech./MCA/MBA/BBA (2025/2026/2027)"
},
{
  id:"38",
  name:"Tech Talk on Thriving in the age of Digital Disruption Through Business Agility",
  date:"09th July",
  speaker:"Dipashree Jha",
  course:"B.Tech./M.Tech./MSc(2025)"
}
];
